<template>
  <section class="h-[calc(95vh-120px)] overflow-y-auto rounded-xl px-4 mx-auto">
    <ReferralEmailContent
      v-if="applicationId"
      :key="`referral-email-${applicationId}`"
      :application-id="applicationId"
      :all-applications="false"
      :is-modal="isModal"
      :on-success="handleEmailSent"
      @email-sent="handleEmailSent"
    />
    <div v-else class="flex items-center justify-center h-full">
      <p class="text-gray-500">No application selected</p>
    </div>
  </section>
</template>

<script setup lang="ts">
import ReferralEmailContent from '@/components/referrals/ReferralEmailContent.vue'

const props = defineProps<{
  applicationId: string | null
  isModal?: boolean
  onSuccess?: () => void
}>()

const emit = defineEmits<{
  (e: 'email-sent'): void
}>()

const handleEmailSent = () => {
  console.log('EmailPreviewTabContent received email-sent, calling onSuccess and re-emitting')
  if (props.onSuccess) {
    props.onSuccess()
  }
  emit('email-sent')
}
</script>